import { Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import React, { useEffect } from "react";
import { Field } from "features/admin/Products/types";
import { useStyles } from "./styles";
import { Controller } from "react-hook-form";

interface CheckboxProps {
  item: Field;
  control: any;
  reset: boolean | undefined;
  setValue: any;
}

const CheckboxField: React.FC<CheckboxProps> = ({
  item,
  control,
  reset,
  setValue,
}) => {
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);
  useEffect(() => {
    if (reset !== undefined) {
      let deff = item.value !== undefined ? item.value : false;
      setChecked(deff);
    }
  }, [reset]);

  useEffect(() => {
    let deff = item.value !== undefined ? item.value : false;
    setChecked(deff);
    setValue(item.name, item.value);
  }, []);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    onChange: any
  ) => {
    setChecked(event.target.checked);
    onChange(event.target.checked);
  };
  return (
    <FormControl required={item.required} className={classes.formControl}>
      <FormControlLabel
        control={
          <Controller
            name={item.name}
            control={control}
            defaultValue={checked}
            value={checked}
            disabled={item.disabled}
            render={({ onChange, onBlur, name }) => (
              <Checkbox
                color="primary"
                onBlur={onBlur}
                onChange={(e) => handleChange(e, onChange)}
                checked={checked}
                disabled={item.disabled}
                name={name}
              />
            )}
          />
        }
        label={item.title}
      />
    </FormControl>
  );
};

export default CheckboxField;
